import React from 'react'

const Vote = () => {
  return (
    <>
      <div style={{ fontSize: "40px", marginTop: "200px" }}>Vote</div>
      <div style={{ fontSize: "40px", marginTop: "10px" }}>Coming Soon...</div>
    </>
  )
}

export default Vote